import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    markClassName?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            aria-hidden='true'
            className={cn('size-8 shrink-0', className)}
        >
            <path
                d='M10.5 11.5c-1.4-1.3-1.4-2.7 0-4s1.4-2.7 0-4'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
            />
            <path
                d='M16 11.5c-1.4-1.4-1.4-2.9 0-4.3s1.4-2.9 0-4.3'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
            />
            <path
                d='M21.5 11.5c-1.4-1.3-1.4-2.7 0-4s1.4-2.7 0-4'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
            />
            <path
                d='M3 14.5h26c0 6.6-5.8 12-13 12S3 21.1 3 14.5z'
                className='fill-primary'
            />
            <path
                d='M7.5 18.6c1.6 2.5 4.7 4.2 8.5 4.2'
                stroke='white'
                strokeOpacity='0.45'
                strokeWidth='1.6'
                strokeLinecap='round'
            />
            <rect
                x='11'
                y='27.2'
                width='10'
                height='2.6'
                rx='1.3'
                className='fill-primary'
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark className={markClassName} />

            <span className='font-heading text-xl font-semibold tracking-tight'>
                {siteConfig.name}
            </span>
        </span>
    )
}
